module.exports = __webpack_public_path__ + "img/MIZUHO.76f8fa15.png";